import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form } from "reactstrap";
import { get, put, post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import Loader from "common/loader";
import UploadImage from "common/uploadImage";
import { SHOW_DRIVER_TYPE, UPDATE_DRIVER_TYPE, ADD_DRIVER_TYPE, LANGUAGES_SEARCH } from "helpers/api_endpoints";

//meta title
document.title = "Edit Driver Type";

const EditDriverType = () => {

    const [loading, setLoading] = useState(true);
    const params = useParams();
    const [id, setid] = useState('');
    const [name, setName] = useState('');
    const [valued, setValued] = useState([]);
    const [languages, setLanguages] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        post(`${LANGUAGES_SEARCH}`,{status:1})
            .then(response => {
                setLanguages(response.data);
                // console.log(languages);
                setLoading(false);
            })
            .catch(error => {
                navigate('/driver-type');
            })
    }, []);

    useEffect(() => {
        get(`${SHOW_DRIVER_TYPE}/${params.id}`)
            .then(response => {
                const status = response.data;
                setid(params.id);
                setName(status.name);
                setValued(status.named);
                setLoading(false);
            })
            .catch(error => {
                console.log(error)
                navigate('/driver-type');
            })
    }, []);

    const handleSubmit = () => {
        console.log()
        // const imagePath = document.getElementById('imagePath').value;
        const config = { id, name };
        {
            put(UPDATE_DRIVER_TYPE, config)
                .then(response => {
                    if (response.code == 200) {
                        navigate('/driver-type', { state: { successMsg: 'Updated SuccessFully' } });
                    }
                })
                .catch(error => {
                    console.log(error.response);
                })
        }
    }

    const handleName = (languageId,value) => {
        if(!valued.title){
            setValued({"title":[{"1":""}]});
            return;  
        } 
        const ln = valued.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            valued.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setName(JSON.stringify(valued));             
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Offers" breadcrumbItem="Edit Driver Type" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                            <Row>

                                            {
                                                languages.map((language, index) => (
                                                    <Row key={index}>
                                                    <div className="form-group col-md-4 mt-2">
                                                        <Label className="form-label"><Trans>Name ({language.name})</Trans></Label>
                                                        <Input
                                                            name="name"
                                                            value={valued.title?valued.title.find(el => {return el[language.id]})?valued.title.find(el => {return el[language.id]})[language.id]:'':JSON.stringify(valued)}
                                                            className="form-control"
                                                            placeholder="Enter  Name"
                                                            type="text"
                                                            onChange={(e) => handleName(language.id,e.target.value)}
                                                            required ></Input>
                                                    </div>
                                                </Row>
                                                ))
                                            }

                                                <div className="mt-4">
                                                    <Button type="submit" color="danger">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                    <Button type="submit" onClick={(e) => setNew(1)} color="info">
                                                        <Trans>Submit As New</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditDriverType
